/** @jsxImportSource @emotion/react */
import {css} from '@emotion/react'
import {AspectImage} from '../generics'

import CloseIcon from '@mui/icons-material/Close'


const cssStyles = (src) => ({
  root: css`
    position: relative;
    width: 100%;
    max-width: 500px;
  `,
  container: css`
    position: relative;
    width: 100%;         
    aspect-ratio: 2 / 3;
    background: url(${src}) center/cover no-repeat;
    overflow: hidden;
    
    &::after {
      content: '';
      position: absolute;
      inset: 0;
      background: inherit;
      background-size: cover;
      background-position: center;
      filter: blur(12px);
      -webkit-filter: blur(8px);
      -webkit-mask-image: linear-gradient(to bottom, transparent 40%, black 100%);
      mask-image: linear-gradient(to bottom, transparent 60%, black 70%);
      pointer-events: none;
    }
  `,
  frostedOverlay: css`
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%; /* This controls how much of the image is frosted */
    background: linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0) 0%,
      rgba(0, 0, 0, 0.5) 50%,
      rgba(0, 0, 0, 0.8) 100%
    );
    z-index: 10;
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
    mask-image: linear-gradient(to bottom, transparent 30%, black 85%);
  `,
  content: css`
    position: relative;
    width: 100%;
    z-index: 20;
   margin-top: -220px;
   background: linear-gradient(
     to bottom,
     transparent 0,
     transparent 100px,
     black 180px,
     black 100%
   );
  `,
  iconCircle: css`
    cursor: pointer;
    top: 10px;
    right: 10px;
    z-index: 20;
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    backdrop-filter: blur(4px);
    -webkit-backdrop-filter: blur(4px); /* Safari support */
    background-color: rgba(255, 255, 255, 0.2);
    border: 1px solid rgba(255, 255, 255, 0.2);
  `
})



const FrostedAspectImage = ({src, alt = 'event poster', aspect = '2:3', close, children}) => {
  const styles = cssStyles(src)

  return (
    <div css={styles.root}>
      <div css={styles.container}>
        <div css={styles.iconCircle} onClick={close}>
          <CloseIcon color='secondary' />
        </div>

        <AspectImage src={src} aspect={aspect} alt={alt} />
        <div css={styles.frostedOverlay} />
      </div>

      <div css={styles.content}>
        {children}
      </div>
    </div>
  )
}



export default FrostedAspectImage

